import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-banner-notification',
  templateUrl: './covid-banner-notification.component.html',
  styleUrls: ['./covid-banner-notification.component.less']
})
export class CovidBannerNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  redirectTo(){
    console.log('redirect to new services running');
    
  }

}
